module.exports = __webpack_public_path__ + "img/noAvailable.6270d932.png";